import { Tooltip } from 'antd';
import React from 'react';
import styled from 'styled-components';

const SpanStyled = styled.div`
    word-break: break-word;
`;

const TooltipContent = styled.div`
    max-width: 400px;
    word-break: break-word;
    white-space: pre-wrap;
    display: -webkit-box;
    -webkit-line-clamp: 8;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const TextColumn = ({ value = '' }: { value: string }) => {
    return (
        <Tooltip title={<TooltipContent>{value || '-'}</TooltipContent>}>
            <SpanStyled className="f-truncate-two-line"> {value || '-'} </SpanStyled>
        </Tooltip>
    );
};

export default TextColumn;
